// edit: zhangmyh 2017-11-2 11:21 AM
import 'components/filesupload'
/* global ko $ u */

let _config
function init (refer) {
  // $('.u-msg-footer').children('.u-msg-cancel').hide()
  let fileId
  let pageType = _config.pageType
  let enterpriseId = _config.enterpriseId || window.global.user.enterpriseId
  let readonly
  let readOnly = function () {
    return readonly
  }
  if (_config.readonly && typeof _config.readonly == 'function') {
    readonly = (_config.readonly() === true)
    readOnly = _config.readonly
  } else {
    readonly = (_config.readonly === true)
  }
  if (readonly) {
    $('.u-msg-footer').find('.u-msg-ok').hide()
  } else {
    $('.u-msg-footer').find('.u-msg-cancel').hide()
  }
  let fileSize
  if (_config.filesize && typeof _config.filesize == 'function') {
    fileSize = _config.filesize
  } else {
    fileSize = ko.observable(0)
  }
  debugger
  switch (pageType) {
    case 'update':
      // fileId = _config.docId + '_' + _config.id
      fileId = _config.id + '_' + _config.sourceId
      break
    case 'apply':
      fileId = _config.id
      break
    case 'doc':
    default:
      fileId = _config.docId
      break
  }

  let vm = {
    id: ko.observable(fileId),
    index: ko.observable(_config.field + '_' + _config.docId),
    enterpriseId: ko.observable(enterpriseId),
    fileSize,
    readOnly,
    groupname: function () {
      var grouppart
      switch (pageType) {
        case 'update':
          grouppart = 'supplyupdate_'
          break
        case 'apply':
          grouppart = 'supplyapply_'
          break
        case 'doc':
        default:
          grouppart = 'supplydoc_'
          break
      }
      return grouppart + _config.field
    },
    callback: function (data) {}
  }

  let app = u.createApp()
  app.init(vm, $('#refer_inform_uploader')[0])
  refer.registerSubmitFunc(() => {
    return true
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    docId: 0,
    id: 0,
    field: '',
    readonly: false,
    pageType: 'doc'
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/uploader_information/index.js